import { Grid, Text, Underline } from '@farmersdog/corgi-x';

import { useIsMobileViewport } from '../../../../hooks';
import { VetRecommendedPlanPill } from '../../../VetRecommendedPlanPill';
import styles from '../RecipesSelection.module.css';

interface VetTopSectionProps {
  petName: string;
  vetName: string;
  freshRecipeNames: string[];
}

export const VetTopSection = ({
  petName,
  vetName,
  freshRecipeNames,
}: VetTopSectionProps) => {
  const isMobile = useIsMobileViewport();

  const hasVetPickedMultipleRecipes = freshRecipeNames.length > 1;

  return (
    <>
      <Grid bottomSpacing={'md'} justify={'center'}>
        <VetRecommendedPlanPill isMobile={isMobile} />
      </Grid>

      <Grid
        className={styles.vetHeadingContainer}
        direction={'column'}
        alignItems={'center'}
      >
        <Text color="Kale3" variant="heading-28" bold role="heading">
          Review {petName}’s plan from <Underline>{vetName}</Underline>
        </Text>

        <Text
          className={styles.vetSubheader}
          variant="article-16"
          align={'center'}
          topSpacing={'md'}
          bottomSpacing={'lg'}
          role="heading"
        >
          {hasVetPickedMultipleRecipes ? 'These' : 'This'} recipe
          {hasVetPickedMultipleRecipes && 's'}{' '}
          {hasVetPickedMultipleRecipes ? 'were' : 'was'} picked by your vet
          specifically for {petName}’s needs. After your first box, you can edit
          recipes, but please check with {vetName} first!
        </Text>
      </Grid>
    </>
  );
};
